import { Application } from '@integro/core';
import { get, set } from 'lodash-es';
import { registerFormatter } from '@integro/slickg';
import { FormatterEx, SlickGrid } from 'slickgrid';
import { AttachmentsHelper } from './helpers/attachments';
import { appHelpers } from './helpers';
import { LazyTabManager } from './utils';

export function initialize(app: Application) {
  const attachmentsHelper = new AttachmentsHelper(app);

  set(app, 'attachments', attachmentsHelper);
  set(app, 'helpers', appHelpers);

  set(app, 'utils', {
    LazyTabManager,
  });

  registerFormatter('statusDot', statusDot);
  registerFormatter('attachment', attachmentsHelper.slickColumnFormatter());

  set(app, 'gridDefaults', {
    rowClass(data: object) {
      if (get(data, 'inactive')) {
        return app.config.bgClass.inactive;
      }
      // if (get(data, 'locked')) {
      //   return app.config.bgClass.locked;
      // }
    },
  });
}

function statusDot() {
  const colors: Dictionary<string> = get(
    window,
    '$app.config.statuses.colors',
  ) as any;

  const statusDotFormatter: FormatterEx<any> = (
    row,
    cell,
    value,
    columnDef,
    dataContext,
    grid: SlickGrid,
  ) => {
    const field = get(columnDef, 'field') || '';
    const fieldValue = field && get(dataContext, field);

    if (!fieldValue) {
      return value;
    }

    const color = get(colors, fieldValue);
    if (!color) {
      return value;
    }
    return `<span class="mr-2 ml-1 text-${color}">⬤</span>${value}`;
  };

  set(statusDotFormatter, 'exportRawData', true);

  return statusDotFormatter;
}
